export default "__VITE_ASSET__DVSQnLya__"